import script from "./NewProgramInSpireStep2View.vue?vue&type=script&setup=true&lang=js"
export * from "./NewProgramInSpireStep2View.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__